import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

const HeaderMenu = styled.div`
  @media ${queries.less.sm} {
    display: none !important;
  }
`

const CSVButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.8125rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 20px;
  margin: 0;
  font-size: 0.875rem;
  background-color: #776cf1;
  color: #fff;
`

const Styles = {
  HeaderMenu,
  CSVButton,
}
export default Styles
